module.exports = __webpack_public_path__ + "static/img/left.23cfca2a.svg";